import React, { useEffect } from 'react';
import { Button, Modal } from 'flowbite-react';
import { HiOutlineExclamationCircle } from 'react-icons/hi';
import { useReducerAsState } from '../../hooks/useReducerAsState';
import { toast } from 'react-toastify';

interface PostalCodeDeleteModalProps {
    open: boolean;
    postCodeId: number;
    onClose: () => void;
    onDelete: (postCodeId: number) => void;
}

interface State {
    isOpen: boolean;
}

const PostalCodeDeleteModal = (props: PostalCodeDeleteModalProps) => {
    const [state, setState] = useReducerAsState<State>({
        isOpen: false
    });

    const _setOpen = (value: boolean) => setState({ isOpen: value });

    useEffect(() => {
        _setOpen(props.open);
    }, [props.open]);

    const _onDeletePressed = () => {
        if (props.postCodeId === -1) {
            toast.error('Debe seleccionar un código postal para eliminarlo');
            return;
        }

        props.onDelete(props.postCodeId);
        _setOpen(false);
    };

    const _onClose = () => {
        _setOpen(false);
        props.onClose();
    };

    return (
        <Modal show={state.isOpen} onClose={_onClose}>
            <Modal.Header>Eliminar código postal</Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                        ¿Está seguro de que desea eliminar este código postal?
                    </h3>
                    <div className="flex justify-center gap-4">
                        <Button color="failure" onClick={_onDeletePressed}>
                            Si, eliminar
                        </Button>
                        <Button color="gray" onClick={_onClose}>
                            No, cancelar
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PostalCodeDeleteModal;
